// Constants
import { Endpoints } from "~constants/endpoints"

// Utils
import { Api } from "~utils/api"
import { urlQueryBuilder } from "~utils/utils"

// Shapes
import { TableOptionsShape } from "~shapes/api-table"
import { LocationShape, GetLocationOptionsShape } from "~shapes/location"

const LocationService = {
  getLocations: async (options?: TableOptionsShape) => {
    let locationsUrl = Endpoints.LOCATIONS.URL

    if (options) {
      const query = urlQueryBuilder(options)
      locationsUrl = `${locationsUrl}?${query}`
    }

    const { data } = await Api.get(locationsUrl)
    return data
  },
  getLocationsBy: async (options: GetLocationOptionsShape) => {
    const locationUrl = `${Endpoints.LOCATIONS.URL}?${urlQueryBuilder(options)}`
    const { data } = await Api.get(locationUrl)
    return data?._embedded?.locations
  },
  postLocation: async (location: LocationShape) => {
    const locationUrl = Endpoints.LOCATIONS.URL
    const response = await Api.post(locationUrl, location)
    return response.data
  },
}

export default LocationService
